import { render, staticRenderFns } from "./mall-config.vue?vue&type=template&id=40b90250&scoped=true"
import script from "./mall-config.vue?vue&type=script&lang=js"
export * from "./mall-config.vue?vue&type=script&lang=js"
import style0 from "./mall-config.vue?vue&type=style&index=0&id=40b90250&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b90250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b90250')) {
      api.createRecord('40b90250', component.options)
    } else {
      api.reload('40b90250', component.options)
    }
    module.hot.accept("./mall-config.vue?vue&type=template&id=40b90250&scoped=true", function () {
      api.rerender('40b90250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/mall-config.vue"
export default component.exports